export const INSIGHT_TABS = {
  HOURS: 'Hours',
  ACTIVITIES_DONE: 'Activities done',
};

export const insightTabList = Object.values(INSIGHT_TABS).map((tabItem) => ({
  value: tabItem,
}));
